/* eslint-disable no-restricted-imports */
import { useEffect, type PropsWithChildren } from 'react'
import { I18nextProvider } from 'react-i18next'

import { useBrowserLanguage } from '../../hooks/useBrowserLanguage'
import { useLanguageState } from '../../hooks/useLanguageState'
import i18n from '../../i18n'
import { FlectoLanguages } from '../../types/FlectoLanguages'

export type TranslationProviderProps = PropsWithChildren & {
  withBrowserLanguageAsDefault?: boolean
}

export function TranslationProvider({
  children,
  withBrowserLanguageAsDefault = false,
}: TranslationProviderProps) {
  const browserLanguage = useBrowserLanguage()
  const { changeLanguage } = useLanguageState()

  useEffect(() => {
    let lang = localStorage.getItem('lang') as FlectoLanguages

    if (!Object.values(FlectoLanguages).includes(lang)) {
      lang = withBrowserLanguageAsDefault
        ? browserLanguage
        : FlectoLanguages.DEFAULT
    }

    changeLanguage(lang)

    i18n.on('languageChanged', (lang) => {
      localStorage.setItem('lang', lang)
    })

    return () => i18n.off('languageChanged')
  }, [browserLanguage])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
